import { render, staticRenderFns } from "./PurchaseDialog.vue?vue&type=template&id=3a5f580a&"
import script from "./PurchaseDialog.vue?vue&type=script&lang=js&"
export * from "./PurchaseDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports